<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <core-card [actions]="[]">
            <div class="card-title w-100">
                <div [ngClass.xl]="'float-left'" [ngClass.md]="'float-left'" [ngClass.sm]="'mb-075'">
                    <label class="d-flex align-items-center">
                        <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control"
                               [(ngModel)]="searchKeyword"/>
                    </label>
                </div>
                <div [ngClass.xl]="'float-left ml-1'" [ngClass.md]="'float-left ml-1'" [ngClass.sm]="'mb-075'">
                    <select [(ngModel)]="searchStatus" class="form-control">
                        <option value="2">{{"ALL_FEMALE_PLURAL" | translate}}</option>
                        <option value="-1">{{"TO_APPROVED" | translate}}</option>
                        <!--<option value="0">{{"DEACTIVATE" | translate}}</option>-->
                    </select>
                </div>
                <div class="float-right">
                    <div [ngClass.xl]="'w-fit d-inline-block mr-2'" [ngClass.md]="'w-fit d-inline-block mr-2'" [ngClass.sm]="'d-none'">
                        <label class="d-flex align-items-center">{{"SHOW" | translate}}
                            <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </label>
                    </div>
                    <a (click)="modalOpen(skillAdd, null)" class="btn btn-outline-primary text-primary" *ngIf="_authenticationService.hasCapability('create_skill')">{{'ADD' | translate}}</a>
                </div>
                <div class="clearboth"></div>
            </div>

            <!--            desktop-->
            <div class="card-body px-0 pb-0" *ngIf="_utilService.isDesktop">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30"
                               [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}"
                               [scrollbarH]="true" [rowHeight]="50" [limit]="tableLimit" [footerHeight]="60" [rows]="skillsList()">
                    <ngx-datatable-column [name]="'NAME' | translate" prop="name" [sortable]="true">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <span>{{ row.name }}</span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [name]="'HOW_MANY_USER_SKILL' | translate" prop="used_in_users" [sortable]="true">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <span>{{ row.used_in_users }}</span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [name]="'STATE' | translate" prop="enabled" [sortable]="true">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <span>{{row.enabled_label}}</span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="{{'ACTIONS' | translate}}" [sortable]="false" width="200">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="d-flex align-items-center">
                                <button (click)="modalOpen(skillEdit, row)" class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('edit_skill')">
                                    <i [data-feather]="'edit-2'" size="19"></i>
                                </button>
                                <button (click)="deleteSkill(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_skill')">
                                    <i [data-feather]="'trash-2'" size="19"></i>
                                </button>
                                <div *ngIf="row.enabled===-1 && _authenticationService.hasCapability('edit_skill')">
                                    <button (click)="approve(row.id)" class="btn btn-outline-primary ml-1 btn-sm">{{"APPROVE" | translate}}</button>
                                    <button (click)="reject(row.id)" class="btn btn-outline-secondary ml-1 btn-sm">{{"REJECT" | translate}}</button>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>

            <!--mobile - tablet-->
            <div class="card-body px-0 pb-0" *ngIf="_utilService.isMobile || _utilService.isTablet">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30"
                               [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}"
                               [scrollbarH]="false" [rowHeight]="110" [limit]="tableLimit" [footerHeight]="60" [rows]="skillsList()">
                    <ngx-datatable-column [name]="'NAME' | translate" prop="name" [width]="null" [sortable]="true">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="row list-item-mobile">
                                <div class="col-12" [ngClass.md]="'pl-0'">
                                    <span>{{ row.name }}</span>
                                </div>
                                <div class="col-12 mt-075 text-right"[ngClass.md]="'pr-2'">
                                    <button (click)="modalOpen(skillEdit, row)" class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('edit_skill')">
                                        <i [data-feather]="'edit-2'" size="19"></i>
                                    </button>
                                    <button (click)="deleteSkill(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_skill')">
                                        <i [data-feather]="'trash-2'" size="19"></i>
                                    </button>
                                    <div *ngIf="row.enabled===-1 && _authenticationService.hasCapability('edit_skill')" class="d-inline-block">
                                        <button (click)="approve(row.id)" class="btn btn-outline-primary ml-1 btn-sm">{{"APPROVE" | translate}}</button>
                                        <button (click)="reject(row.id)" class="btn btn-outline-secondary ml-1 btn-sm">{{"REJECT" | translate}}</button>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>
        </core-card>
    </div>
</div>
<!-- Modal Add -->
<ng-template #skillAdd let-modal>
    <form (ngSubmit)="addSkill()">
        <div class="modal-header">
            <div></div>
            <button type="button" class="close" (click)="modal.dismiss('Cross click')"
                    aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" tabindex="0">
            <h3>{{"ERRORS.ADD_NEW_SKILL" | translate}}</h3>
            <label [for]="'new_skill'">{{'SKILL' | translate}}<sup class="text-danger">*</sup></label>
            <input [(ngModel)]="new_skill" name="new_skill" type="text" [id]="'new_skill'" class="form-control"/>
            <div class="font-error" *ngIf="showModalError && (!new_skill || new_skill.length < 1)">{{ 'ERRORS.FIELD_SKILL' | translate }}</div>
        </div>
        <div class="modal-footer d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close()" rippleEffect>
                {{"CANCEL" | translate}}
            </button>
            <button  type="submit" class="btn btn-primary w-150" rippleEffect>
                {{"SEND" | translate}}
            </button>
        </div>
    </form>
</ng-template>
<!-- / Modal Add -->

<!-- Modal Edit -->
<ng-template #skillEdit let-modal>
    <form (ngSubmit)="editSkill()">
        <div class="modal-header">
            <div></div>
            <button type="button" class="close" (click)="modal.close()"
                    aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" tabindex="0">
            <h3>{{"EDIT" | translate}} {{"SKILL" | translate}}</h3>
            <label [for]="'skill'">{{'SKILL' | translate}}<sup class="text-danger">*</sup></label>
            <input name="currentSkillName" [(ngModel)]="currentSkill.name" type="text" [id]="'skill'" class="form-control"/>
            <div class="font-error" *ngIf="showModalError && (!currentSkill.name || currentSkill.name.length < 1)">{{ 'ERRORS.FIELD_SKILL' | translate }}</div>
        </div>
        <div class="modal-footer d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary w-150"
                    (click)="modal.close()"
                    rippleEffect>
                {{"CANCEL" | translate}}
            </button>
            <button type="submit" class="btn btn-primary w-150" rippleEffect>
                {{"EDIT" | translate}}
            </button>
        </div>
    </form>
</ng-template>
<!-- / Modal Edit -->